import { render } from "./PillText.vue?vue&type=template&id=50186468&scoped=true"
import script from "./PillText.vue?vue&type=script&lang=js"
export * from "./PillText.vue?vue&type=script&lang=js"

import "./PillText.vue?vue&type=style&index=0&id=50186468&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\nicol\\Code\\portfolio_new\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50186468"]])

export default __exports__